import React, { useEffect } from "react";
import firstSectionImg2 from "../assests/revamp/feature-outsourcing.png";
import AOS from "aos";
import "aos/dist/aos.css";
import ctaBandImg from "../assests/revamp/cta-band-staffing.png";
import { useLanguage } from "../i18n/LanguageContext";

export default function Outsourcing() {
  const { t } = useLanguage();

  const handleGetInTouch = () => {
    const getInTouchSection = document.getElementById("contact_us");
    if (getInTouchSection) {
      const topOffset = getInTouchSection.offsetTop - 90;
      window.scrollTo({
        top: topOffset,
        behavior: "smooth",
      });
    }
  };
  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: "ease",
      delay: 100,
    });
  }, []);
  return (
    <div className="outsourcingMain" id="about__Us">
      <div className="firstSection">
        <div className="firstSectionContainer">
          <div data-aos="fade-down-right" className="firstSectionChild1">
            <h2 className="firstSectionChild1Head">{t("about.partnerHead")}</h2>
            <p className="firstSectionChild1Para">{t("about.partnerBody")}</p>
          </div>
          <div data-aos="fade-down-left" className="firstSectionChild2">
            <img
              className="zoom-effect"
              style={{ width: "100%" }}
              src={firstSectionImg2}
              alt={t("about.mediaAlt")}
            />
          </div>
        </div>

        <div data-aos="fade-up" className="amgAboutStory">
          <div className="firstSectionContainerTwo">
            <p className="amgAboutStoryEyebrow">{t("about.storyEyebrow")}</p>
            <h2 className="firstSectionContainerTwoHead">{t("about.whoHead")}</h2>
            <p className="firstSectionContainerTwoPara">{t("about.whoBody")}</p>
            <p className="amgAboutTrustLine">
              {t("about.licensedLine")}{" "}
              <button
                type="button"
                className="amgAboutTrustLink"
                onClick={handleGetInTouch}
              >
                {t("about.requestLicence")}
              </button>
            </p>
          </div>
          <div className="amgAboutFootprint" aria-label={t("about.footprintAria")}>
            <p className="amgAboutFootprintTitle">{t("about.footprintTitle")}</p>
            <div className="amgAboutFootprintItem">
              <span className="amgAboutFootprintDot" aria-hidden="true" />
              <div>
                <h3>{t("about.uaeTitle")}</h3>
                <p>{t("about.uaeBody")}</p>
              </div>
            </div>
            <div className="amgAboutFootprintItem">
              <span className="amgAboutFootprintDot" aria-hidden="true" />
              <div>
                <h3>{t("about.hubTitle")}</h3>
                <p>{t("about.hubBody")}</p>
              </div>
            </div>
            <div className="amgAboutFootprintItem">
              <span className="amgAboutFootprintDot" aria-hidden="true" />
              <div>
                <h3>{t("about.westTitle")}</h3>
                <p>{t("about.westBody")}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <section className="secondSection" data-aos="fade-up">
        <img src={ctaBandImg} alt="" aria-hidden="true" />
        <div className="secondSectionContent">
          <p className="secondSectionEyebrow">{t("about.ctaEyebrow")}</p>
          <h2 className="secondSectionHead">{t("about.ctaHead")}</h2>
          <p className="secondSectionPara">{t("about.ctaBody")}</p>
          <button
            type="button"
            onClick={handleGetInTouch}
            className="secondSectionBtn"
          >
            {t("about.ctaBtn")}
          </button>
        </div>
      </section>
    </div>
  );
}
